export default __webpack_public_path__ + "static/media/acuityB.129fd61d.svg";